enum GridPreferencePanelsValue {
  filters = 'filters',
  columns = 'columns',
  aiAssistant = 'aiAssistant',
}

export { GridPreferencePanelsValue };
